import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Moment from 'react-moment'
import { controlledProductsActions } from '../../actions'
import { pxToRem, color } from '../../utils'
import { Grid, Content } from '../../components/Layout'
import DataTable from '../../components/Table/Table'
import Header from '../../components/Header'
import Modal from '../../components/Modal'
import Sidebar from '../../components/Sidebar'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import statusSuccess from '../../assets/icons/status-success.svg'
import ContentHeader from '../../components/ContentHeader'
import dateToBrFormat from '../../utils/dateToBrFormat'

const ModalLayout = styled.div`
  display: flex;
  padding-left: ${pxToRem(20)};
  padding-right: ${pxToRem(20)};
  flex-wrap: wrap;
  > div {
    flex: 1;
    margin: 0 1em;
    padding-top: ${pxToRem(20)};
    padding-bottom: ${pxToRem(20)};
    &:first-child {
      flex: auto;
      flex: 0 1 ${pxToRem(240)};
      border-right: 1px solid #d3dce2;
      margin-right: ${pxToRem(20)};
      padding-bottom: 0;
    }
  }
  @media only screen and (max-width: 965px) {
    flex-direction: column;
    div {
      flex: 0 !important;
      padding-left: 0 !important;
      margin-left: 0 !important;
      &:first-child {
        border: none;
      }
    }
  }
`

const WrapperStatus = styled.div`
  width: 20px;
  height: 20px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    margin: auto;
    width: 14px;
  }

  ${({ type }) => {
    return `background: ${type === 'true' ? color.success : null}`
  }};
`

const Ulist = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  max-height: 220px;
  overflow: auto;

  li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.3em;
    padding-left: 0.6em;
    &::before {
      content: '';
      display: inline-block;
      width: ${pxToRem(8)};
      height: ${pxToRem(8)};
      border-radius: 50%;
      background-color: ${color.secondary};
      box-shadow: 0 0 10px 0 ${color.secondary};
      margin-right: 1em;
    }
    span {
      flex: 1;
      color: ${color.primary} !important;
    }
  }
`

const DefinitionList = styled.dl`
  margin: 2em 0;
  &:first-child {
    margin-top: 0;
  }
  dd,
  dt {
    padding: 0;
    margin: 0;
    font-size: ${pxToRem(14)};
  }
  dd {
    span,
    strong {
      color: ${color.secondary};
    }
    strong {
      font-weight: bold;
    }
  }
  dt {
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 1em;
  }
  & > dl {
    overflow: auto;
    margin-top: 0;
    max-height: 260px;
  }
  dl {
    &:first-child {
      margin-top: 0;
    }
    dt {
      color: ${color.primary};
      margin-bottom: 0;
      font-weight: bold;
    }
  }
`

const ProductLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const simpleList = (item, ...args) => {
  const [word, index, length] = args
  return index < length - 1 ? `${word}, ` : `${word}.`
}

const columns = {
  id: {
    hide: true
  },
  name: {
    label: 'Nome Comercial',
    sortable: true,
    width: 210
  },
  controlled_component_names: {
    label: 'Componente Controlado',
    sortable: true,
    width: 150
  },
  pc: {
    label: 'Polícia Civil',
    sortable: false,
    width: 70,
    CellComponent: ({ value }) => {
      const icon = value === true ? statusSuccess : null
      return (
        <WrapperStatus data-tip={value} type={`${value}`}>
          <span aria-hidden={true}>
            <img src={icon} alt={value.info} />
          </span>
        </WrapperStatus>
      )
    }
  },
  pf: {
    label: 'Polícia Federal',
    sortable: false,
    width: 70,
    CellComponent: ({ value }) => {
      const icon = value === true ? statusSuccess : null
      return (
        <WrapperStatus data-tip={value} type={`${value}`}>
          <span aria-hidden={true}>
            <img src={icon} alt={value.info} />
          </span>
        </WrapperStatus>
      )
    }
  },
  eb: {
    label: 'Exército Brasileiro',
    sortable: false,
    width: 70,
    CellComponent: ({ value }) => {
      const icon = value === true ? statusSuccess : null
      return (
        <WrapperStatus data-tip={value} type={`${value}`}>
          <span aria-hidden={true}>
            <img src={icon} alt={value.info} />
          </span>
        </WrapperStatus>
      )
    }
  },
}

class List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openProductModal: false
    }
  }

  componentDidMount() {
    this.props.fetchProducts(this.props.areaId)
  }

  closeModal = () => {
    this.setState(state => ({
      openProductModal: false
    }))
  }

  openModal = (e, id) => {
    e.preventDefault()
    this.props.fetchItem(this.props.areaId, id)
    this.setState(state => ({
      openProductModal: true
    }))
  }

  componentDidUpdate(prevProps) {
    if (this.props.areaId && this.props.areaId !== prevProps.areaId) {
      this.props.fetchProducts(this.props.areaId)
    }
  }

  render() {
    const {
      menuItems = [],
      router,
      fetchProducts,
      controlledProducts,
      last_update,
      fetching,
      product = {},
      fetch_errors
    } = this.props

    const { closeModal, openModal } = this
    const { openProductModal } = this.state

    const CellComponent = ({ name, value, row, ...rest }) => {
      return (
        <ProductLink {...rest} onClick={e => openModal(e, row.id)}>
          {value}
        </ProductLink>
      )
    }

    columns['name'] = { ...columns['name'], CellComponent }

    return (
      <Fragment>
        <Grid>
          <Header router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content>
            <ContentHeader
              title="Produtos Controlados"
              subtitle="Relação de Produtos Controlados"
              last_update={dateToBrFormat(new Date(last_update))}
            >
            </ContentHeader>
            <DataTable
              loading={fetching.products}
              error={fetch_errors.products}
              fetchData={fetchProducts}
              columns={columns}
              height={900}
              width={1100}
              data={controlledProducts}
            />
            <ResponsiblesContent />
          </Content>
        </Grid>
        <Modal
          title={product.name}
          safeContent={false}
          loading={fetching.product}
          open={openProductModal}
          error={fetch_errors.product}
          size={'large'}
          closeMethod={closeModal}
        >
          <ModalLayout>
            <div>
              <DefinitionList>
                <dt>Órgãos Fiscalizadores</dt>
                <dd>
                  {(product['supervisories'] || []).map(
                    (item, index) =>
                      simpleList`${item.name} ${index} ${product['supervisories'].length}`
                  )}
                </dd>
              </DefinitionList>
            </div>
            <div>
              <DefinitionList>
                <dt>Componentes Controlados</dt>
                <dd>
                  {(product['controlled_components'] || []).length ? (
                    <Ulist>
                      {(product['controlled_components'] || []).map((item, index) => (
                        <li>
                          <span>{`${item.name}`}</span>
                        </li>
                      ))}
                    </Ulist>
                  ) : (
                    <Ulist>
                      <li>Não há componentes controlados</li>
                    </Ulist>
                  )}
                </dd>
              </DefinitionList>
              {product.areas && (
                <DefinitionList>
                  <dt>Areas</dt>
                  <dd>
                    <Ulist>
                      <li><span>{product.areas}</span></li>
                    </Ulist>
                  </dd>
                </DefinitionList>
              )}
            </div>
          </ModalLayout>
        </Modal>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  product: state.controlledProducts.product,
  fetching: state.controlledProducts.fetching,
  fetch_errors: state.controlledProducts.fetch_errors,
  controlledProducts: state.controlledProducts.items,
  last_update: state.controlledProducts.last_update,
  areaId: state.auth.areaId
})

const mapDispatchToProps = dispatch => {
  return {
    fetchProducts: areaId => {
      dispatch(controlledProductsActions.fetchProducts(areaId))
    },
    fetchItem: (areaId, id) => {
      dispatch(controlledProductsActions.fetchProduct(areaId, id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/containers/ControlledProducts/List.js